import { render } from "./ProfileSubSectionHeader.vue?vue&type=template&id=159276c6&scoped=true"
import script from "./ProfileSubSectionHeader.vue?vue&type=script&lang=js"
export * from "./ProfileSubSectionHeader.vue?vue&type=script&lang=js"

import "./ProfileSubSectionHeader.vue?vue&type=style&index=0&id=159276c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159276c6"]])

export default __exports__